// src/components/Footer.js
import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { currentTheme } = useContext(ThemeContext);

  return (
    <footer className="text-center py-3 mt-auto enhanced-shadow" style={{
      background: `linear-gradient(135deg, ${currentTheme.primary}, ${currentTheme.secondary})`,
      borderTop: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <div className="container">
        <p className="mb-0 small text-white fw-medium">
          &copy; {currentYear} <strong>TrackFlow</strong> — All rights reserved.
        </p>
      </div>
      
      <style jsx="true">{`
        .enhanced-shadow {
          box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1) !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;